var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"placeholder"},[_c('div',{staticClass:"content"},[_c(_setup.LoadingSpinner),_c('div',{staticClass:"description"},[_vm._v("It'll only take a moment")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }